import { ETipoUnidadSUNAT } from './tipoUnidadSUNAT.enum';

const FACTORES_CONVERSION: Record<string, Record<string, number>> = {
  [ETipoUnidadSUNAT.KILOGRAMO]: { [ETipoUnidadSUNAT.GRAMO]: 1000 },
  [ETipoUnidadSUNAT.GRAMO]: { [ETipoUnidadSUNAT.KILOGRAMO]: 0.001 },
  [ETipoUnidadSUNAT.LITRO]: { [ETipoUnidadSUNAT.MILILITRO]: 1000 },
  [ETipoUnidadSUNAT.MILILITRO]: { [ETipoUnidadSUNAT.LITRO]: 0.001 },
};

const FAMILIAS_UNIDADES: ETipoUnidadSUNAT[][] = [
  [ETipoUnidadSUNAT.KILOGRAMO, ETipoUnidadSUNAT.GRAMO],
  [ETipoUnidadSUNAT.LITRO, ETipoUnidadSUNAT.MILILITRO],
];

export function unidadesCompatibles(unidad: ETipoUnidadSUNAT): ETipoUnidadSUNAT[] {
  for (const familia of FAMILIAS_UNIDADES) {
    if (familia.includes(unidad)) return familia;
  }
  return [unidad];
}

export function convertirUnidad(cantidad: number, desde: ETipoUnidadSUNAT, hacia: ETipoUnidadSUNAT): number {
  if (desde === hacia) return cantidad;
  const factor = FACTORES_CONVERSION[desde]?.[hacia];
  if (factor === undefined) return cantidad;
  return cantidad * factor;
}